import { render } from "./DashboardShell.vue?vue&type=template&id=461e36ff&scoped=true"
import script from "./DashboardShell.vue?vue&type=script&lang=js"
export * from "./DashboardShell.vue?vue&type=script&lang=js"

import "./DashboardShell.vue?vue&type=style&index=0&id=461e36ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461e36ff"]])

export default __exports__